import { Component, OnDestroy, OnInit } from '@angular/core';
import { BidListStateService } from '../../services/bid-list-state-service/bid-list-state.service';
import { CommonListComponent } from '../common-list/common-list.component';

@Component({
    selector: 'app-sharedlists',
    templateUrl: './sharedlists.component.html',
    styleUrls: ['./sharedlists.component.scss'],
    imports: [CommonListComponent]
})
export class SharedlistsComponent implements OnInit, OnDestroy {

  constructor(
		readonly bidListStateService: BidListStateService
  ) {}

  ngOnInit() {
    this.bidListStateService.isSharedList = true;
  }

  ngOnDestroy() {
    this.bidListStateService.isSharedList = false;
  }
}
